import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Recolha',
  [OrderMethod.Delivery]: 'Entrega',
  [OrderMethod.OnSite]: 'No local',
};
